import CompanyHotel from '@app/model/company_hotel/CompanyHotel';
import CompanyHotelParsingSettingState from '@app/model/company_hotel/CompanyHotelParsingSettingState';
import DataProvider from '@app/model/_common/DataProvider';
import DataPlatform from '@app/model/_common/DataPlatform';
import RatesType from '@app/model/market_state/RatesType';

export const channelCheckStayLengths = (companyHotel: CompanyHotel): number[] =>
	Array.from(new Set((companyHotel.parsingSettings ?? [])
		.filter(setting => setting.state === CompanyHotelParsingSettingState.ACTIVE
			&& setting.variables.provider === DataProvider.BOOKING
			&& String(setting.variables.platform) === DataPlatform.WEB
			&& setting.variables.ratesType === RatesType.PUBLIC)
		.flatMap(setting => setting.nights ?? [])))
		.sort((left, right) => right - left);
